
import img1 from "../../../assets/Images/slider/5.jpg";
import img2 from "../../../assets/Images/slider/6.jpg";
import img3 from "../../../assets/Images/slider/7.jpg";
import img4 from "../../../assets/Images/slider/8.jpg";
import img5 from "../../../assets/Images/slider/9.jpg";


export const RecentArticalData = [
    {
        id: 1,
        image: img1,
        name: "We are like Tea, we don't know our own Strength until we're in Hot Water",
        blog_date: "02 April 2021",
        by: "Admin",
        content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis authore irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    },
    {
        id: 2,
        image: img2,
        name: "At we thrive on the unique backgrounds, experiences, and perspectives of our people.",
        blog_date: "02 April 2021",
        by: "Admin",
        content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis authore irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    },
    {
        id: 3,
        image: img5,
        name: "At we thrive on the unique backgrounds, experiences, and perspectives of our people.",
        blog_date: "02 April 2021",
        by: "Admin",
        content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis authore irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    },
    {
        id: 4,
        image: img4,
        name: "At we thrive on the unique backgrounds, experiences, and perspectives of our people.",
        blog_date: "02 April 2021",
        by: "Admin",
        content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis authore irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    },
    {
        id: 5,
        image: img3,
        name: "At we thrive on the unique backgrounds, experiences, and perspectives of our people.",
        blog_date: "02 April 2021",
        by: "Admin",
        content: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis authore irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    }
]